// extracted by mini-css-extract-plugin
export default {"actionItemWrapper":"_8ed3b7dcf62dc7ce","tableTitle":"c639ad513c250cef"};